export default __webpack_public_path__ + "static/media/powerPlayIcon2.83dc415b.png";